export const getCoteChalonnaiseData = () => ({
  name: "Côte Chalonnaise",
  region: "Bourgogne",
  country: "France",
  description: "La Côte Chalonnaise est la région méridionale de la Bourgogne, produisant des vins de qualité à prix abordables avec un excellent rapport qualité-prix.",
  type: "subregion",
  area: "1,800 ha",
  production: "90,000 hectolitres",
  mapAreas: [
    { region: "Côte Chalonnaise", x: 54, y: 62, color: "#4B164C", size: 4 }
  ],
  characteristics: {
    climate: "Climat continental tempéré, hivers froids, étés chauds",
    soil: "Sols argilo-calcaires, marnes, calcaires",
    viticulture: "Viticulture traditionnelle, rendements modérés, vendanges manuelles"
  },
  wineStyles: {
    red: "Vins rouges équilibrés et fruités, avec des notes de fruits rouges et d'épices douces",
    white: "Vins blancs secs et aromatiques, avec des notes de fruits blancs et de fleurs"
  },
  history: "La Côte Chalonnaise produit des vins depuis l'époque romaine. La région a développé sa viticulture au Moyen Âge. Aujourd'hui, elle est reconnue pour son excellent rapport qualité-prix.",
  foodPairing: "Viandes blanches, volailles, poissons, fromages doux",
  grapeVarieties: [
    {
      name: "Chardonnay",
      percentage: "50%",
      description: "Cépage principal de la Côte Chalonnaise, produisant des vins blancs secs et aromatiques",
      characteristics: "Sec, aromatique, notes de fruits blancs et de fleurs",
      wineStyles: "Sec, moyen-corps, aromatique"
    },
    {
      name: "Pinot Noir",
      percentage: "40%",
      description: "Cépage rouge de la Côte Chalonnaise, produisant des vins équilibrés et fruités",
      characteristics: "Équilibré, fruité, tanins doux, notes de fruits rouges",
      wineStyles: "Sec, moyen-corps, fruité"
    },
    {
      name: "Aligoté",
      percentage: "10%",
      description: "Cépage traditionnel, produisant des vins secs et vifs",
      characteristics: "Sec, vif, acidité vive, notes d'agrumes",
      wineStyles: "Sec, léger, vif"
    }
  ]
}); 